export const partnerCodeGroupUISchema = {
  type: "VerticalLayout",
  elements: [
    {
      type: "HorizontalLayout",
      elements: [
        {
          type: "VerticalLayout",
          elements: [
            {
              type: "Control",
              scope: "#/properties/name",
              component: "textInput",
            },
            {
              type: "Control",
              scope: "#/properties/partnerId",
              component: "partnerSelect",
              placeholder: "Select Partner",
              options: {
                className: "partner-codegroup-select",
              },
            },
            {
              type: "Control",
              scope: "#/properties/singleCode",
              component: "textInput",
              placeholder:
                "Enter an alphanumeric code or a valid URL. This code/link can be redeemed by unlimited users",
              rule: {
                effect: "SHOW",
                condition: {
                  scope: "#/properties/codeGroupType",
                  schema: {
                    const: "UNLIMITED_CODE",
                  },
                },
              },
            },
            {
              type: "Control",
              scope: "#/properties/codeWarningLimitPercentage",
              component: "textInput",
              options: {
                type: "number",
                min: 0,
                max: 100,
                maxLength: 3,
              },
              rule: {
                effect: "SHOW",
                condition: {
                  scope: "#/properties/codeGroupType",
                  schema: {
                    const: "UPLOAD_LIST",
                  },
                },
              },
            },
            {
              type: "Control",
              scope: "#/properties/notificationEmails",
              component: "emailChips",
              placeholder: "Enter e-mails here, use comma for more than one",
              rule: {
                effect: "SHOW",
                condition: {
                  scope: "#/properties/codeGroupType",
                  schema: {
                    const: "UPLOAD_LIST",
                  },
                },
              },
            },
          ],
        },
        {
          type: "VerticalLayout",
          elements: [
            {
              type: "Control",
              scope: "#/properties/startDate",
              component: "dateTimePicker",
              minimum: "currentDateTime",
            },
            {
              type: "Control",
              scope: "#/properties/endDate",
              component: "dateTimePicker",
              minimum: "currentDateTime",
              rule: {
                condition: {
                  schema: { gt: "startDate" },
                },
                effect: "VALIDATE",
              },
            },
            {
              type: "Control",
              scope: "#/properties/description",
              component: "textarea",
            },
          ],
        },
      ],
    },
    {
      component: "partnerFileUpload",
      scope: "#/properties/rewardItemFileData",
      type: "Control",
      accept: ".txt",
      description: "Select a file",
      rule: {
        effect: "SHOW",
        condition: {
          scope: "#/properties/codeGroupType",
          schema: {
            const: "UPLOAD_LIST",
          },
        },
      },
    },
  ],
};

export const partnerCodeGroupJsonSchema = {
  type: "object",
  properties: {
    rewardItemFileData: {
      type: "array",
      items: { type: "object" },
      title: "Import Code",
    },
    startDate: { type: "string", title: "Start Date" },
    endDate: { type: "string", title: "End Date" },
    name: { type: "string", title: "Name", minLength: 1 },
    description: { type: "string", title: "Description", minLength: 1 },
    partnerId: { type: "string", title: "Partner", label: "Partner" },
    codeGroupType: {
      type: "string",
      title: "Code Group Type",
      enum: ["UPLOAD_LIST", "UNLIMITED_CODE"],
      enumNames: ["Upload List", "Unlimited Code"],
    },
    singleCode: {
      type: ["string", "null"],
      title: "Generic Unlimited Code or Link",
      pattern:
        "^([a-zA-Z0-9]+|https?:\\/\\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\\.[a-zA-Z]{2,})+(\\/[^\\s]*)?)$",
      message:
        "Invalid format. Enter alphanumeric code or valid URL (http:// or https://)",
    },
    codeWarningLimitPercentage: {
      type: "number",
      title: "Code Warning Limit",
      default: 0,
      minimum: 0,
      maximum: 100,
    },
    isActive: { type: "boolean", title: "Is Active", default: false },
    notificationEmails: {
      type: ["string", "null"],
      title: "Emails for Warning",
    },
  },
  required: [
    "startDate",
    "endDate",
    "name",
    "description",
    "partnerId",
    "codeGroupType",
    "isActive",
  ],
  allOf: [
    {
      if: {
        properties: {
          codeGroupType: { const: "UPLOAD_LIST" },
        },
      },
      then: {
        required: ["rewardItemFileData"],
        properties: {
          rewardItemFileData: { minItems: 1 },
        },
      },
    },
    {
      if: {
        properties: {
          codeGroupType: { const: "UNLIMITED_CODE" },
        },
      },
      then: {
        required: ["singleCode"],
        properties: {
          singleCode: { minLength: 1 },
        },
      },
    },
  ],
};
